/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Extended_Ad_LabelInputs */

const en_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extended AD`)
};

const fr_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD étendue`)
};

const de_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Werbung`)
};

const it_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuncio esteso`)
};

const ru_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширенная AD`)
};

const es_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD extendido`)
};

const zh_cn2_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩展广告`)
};

const ja_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張AD`)
};

const hi_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विस्तारित विज्ञापन`)
};

const pt_pt2_audio_description_export_extended_ad_label = /** @type {(inputs: Audio_Description_Export_Extended_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD estendido`)
};

/**
* | output |
* | --- |
* | "Extended AD" |
*
* @param {Audio_Description_Export_Extended_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_extended_ad_label = /** @type {((inputs?: Audio_Description_Export_Extended_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Extended_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_extended_ad_label(inputs)
	if (locale === "de") return de_audio_description_export_extended_ad_label(inputs)
	if (locale === "it") return it_audio_description_export_extended_ad_label(inputs)
	if (locale === "ru") return ru_audio_description_export_extended_ad_label(inputs)
	if (locale === "es") return es_audio_description_export_extended_ad_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_extended_ad_label(inputs)
	if (locale === "ja") return ja_audio_description_export_extended_ad_label(inputs)
	if (locale === "hi") return hi_audio_description_export_extended_ad_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_extended_ad_label(inputs)
	return en_audio_description_export_extended_ad_label(inputs)
});